import { render, staticRenderFns } from "./payments_stat.vue?vue&type=template&id=0496d16d&scoped=true&"
import script from "./payments_stat.vue?vue&type=script&lang=js&"
export * from "./payments_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496d16d",
  null
  
)

export default component.exports